"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Marcus Thorne",
  quote: "Nova Project Management streamlined our international logistics with surgical precision. Their global perspective is unmatched.",
  position: "Director of Operations, Global Logistics Co.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/executive_marcus_thorne.png"
}, {
  author: "Elena Rodriguez",
  quote: "The level of technical detail and resource allocation they provided for our construction project was truly world-class.",
  position: "VP of Infrastructure, Urban Dev Group",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/executive_elena_rodriguez.png"
}, {
  author: "David Chen",
  quote: "Fostering stakeholder relationships across three continents seemed impossible until Nova took the lead on our launch.",
  position: "Chief Strategy Officer, Tech Horizon",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/executive_david_chen.png"
}];
export default function ClientSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}